import React, { useLayoutEffect, useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { useNavigate, useParams } from "react-router-dom";
import { RollbackOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  Layout,
  Col,
  Row,
  Select,
  List,
  Space,
  TimePicker,
  Divider,
} from "antd";
import { Button, Card, Form, Spin, Avatar, Input } from "antd";
import {
  displayMessage,
  generateSlug,
  getAPI,
  postAPI,
} from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import {
  ROOM_CATEGORY,
  FACILITY_BY_TYPE,
  CREATE_ROOMS,
  IMAGE_BASE_URL,
  ROOMS_BY_ID,
} from "../../constants/api";
import ImageSelect from "../images/ImageSelect";
import JoditEditor from "jodit-react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  OTA_SERVICE_TYPE,
  ROOM_CAPACITY_TYPES,
} from "../../constants/constent";
dayjs.extend(customParseFormat);

function RoomAdd() {
  const { Content } = Layout;
  const { id } = useParams();
  let history = useNavigate();
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [facilityList, setFacility] = useState([]);
  const [categoryList, setCategory] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // For Image Selection
  const [selectedImages, setSelectedImages] = useState([]);
  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const handleDialogOk = (selectedImages) => {
    if (selectedImages.length > 0) {
      const selectedImage = selectedImages.map((image) => image);
      setSelectedImages(selectedImage);
      form.setFieldsValue({ room_image: selectedImage.length });
    } else {
      displayMessage(ERROR_MSG_TYPE, "Image not selected");
    }
  };

  const removeSelectedImage = (filePathToRemove) => {
    const updatedSelectedFileValues = selectedImages.filter(
      (filePath) => filePath.filePath !== filePathToRemove
    );
    console.log(updatedSelectedFileValues);
    setSelectedImages(updatedSelectedFileValues);
    form.setFieldsValue({ image: updatedSelectedFileValues.length });
  };

  useLayoutEffect(() => {
    getFacility();
    getCategory();
    if (id) {
      getIdDetail();
    }
  }, []);

  const getIdDetail = () => {
    setIsLoading(true);
    var data = new FormData();
    data.append("room_no", id);
    const successFn = function (data) {
      if (data.status === true) {
        form.setFieldsValue({
          qty: 1,
          copy_id: data.data.id,
          room_name: data.data.room_name,
          room_amt: data.data.room_amt,
          slug: data.data.slug,
          room_category: parseInt(data.data.room_category),
          room_type: data.data.room_type,
          occupancy: data.data.occupancy,
          room_facility: data.data.room_facility.map((e) =>
            parseInt(e.facility.id)
          ),
          room_description: data.data.room_description,
          seo_title: data.data.seo_title,
          seo_keyword: data.data.seo_keyword,
          seo_description: data.data.seo_description,
          room_check_in: dayjs(data.data.room_check_in),
          room_check_out: dayjs(data.data.room_check_out),
          //
          // ota_room_code: data.data.ota_room_code,
          // ota_configs: data.data.ota_configs,
        });
        // For Image
        const selectedImages = data.data.room_images.map(
          (image) => image.image
        );
        setSelectedImages(selectedImages);
        form.setFieldsValue({ room_image: selectedImages.length });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    postAPI(ROOMS_BY_ID, data, successFn, errorFn);
  };
  const getFacility = () => {
    setIsLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        setFacility(data.data.map((e) => ({ value: e.id, label: e.title })));
      } else {
        setFacility([]);
        setIsLoading(false);
      }
    };
    const errorFn = function () {
      setFacility([]);
      setIsLoading(false);
    };
    postAPI(FACILITY_BY_TYPE, { type: "room" }, successFn, errorFn);
  };

  const getCategory = () => {
    setIsLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        setCategory(data.data.map((e) => ({ value: e.id, label: e.title })));
      } else {
        setCategory([]);
        setIsLoading(false);
      }
    };
    const errorFn = function () {
      setCategory([]);
      setIsLoading(false);
    };
    getAPI(ROOM_CATEGORY, successFn, errorFn, {});
  };

  // Handle title change and update slug
  const handleTitleChange = (event) => {
    const newTitle = event.target.value;
    form.setFieldsValue({ slug: generateSlug(newTitle) });
  };

  const createData = (values) => {
    setIsLoading(true);
    const jsonData = {
      room_name: values.room_name,
      qty: values.qty,
      // room_no: values.room_no,
      room_amt: values.room_amt,
      slug: values.slug,
      room_category: values.room_category,
      room_type: values.room_type,
      occupancy: values.occupancy,
      room_facility: values.room_facility,
      room_description: values.room_description,
      seo_title: values.seo_title,
      seo_keyword: values.seo_keyword,
      seo_description: values.seo_description,
      room_check_in: dayjs(values.room_check_in).add(330, "minutes"),
      room_check_out: dayjs(values.room_check_out).add(330, "minutes"),
      room_images: Array.from(selectedImages).map((element) => element.id),

      //
      ota_room_code: values.ota_room_code,
      ota_configs: values.ota_configs,
    };
    if (id) {
      jsonData.copy_id = values.copy_id;
    }

    console.log("createData: ", jsonData);

    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        history("/room");
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Save Data");
    };
    postAPI(CREATE_ROOMS, jsonData, successFn, errorFn);
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Spin spinning={loading}>
            <Card
              title="Create Room"
              bordered={false}
              extra={
                <Button
                  style={{
                    marginTop: "5px",
                    marginBottom: "5px",
                  }}
                  onClick={() => navigate(-1)}
                  type="primary"
                  ghost
                >
                  <RollbackOutlined />
                </Button>
              }
            >
              <Form form={form} layout="vertical" onFinish={createData}>
                <Form.Item name="copy_id" hidden />
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Form.Item
                      name="room_name"
                      label="Room Name"
                      rules={[
                        { required: true, message: "Room Name is required!" },
                      ]}
                      onChange={handleTitleChange}
                    >
                      <Input type={"text"} placeholder="Room Name" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="qty"
                      label="Room QTY"
                      rules={[
                        {
                          required: true,
                          message: "Room QTY is required!",
                        },
                      ]}
                    >
                      <Input type={"text"} placeholder="Room QTY" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="room_amt"
                      label="Room Amount"
                      rules={[
                        {
                          required: true,
                          message: "Room Amount is required!",
                        },
                      ]}
                    >
                      <Input type={"text"} placeholder="Room Amount" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="room_category"
                      label="Room Category"
                      rules={[
                        {
                          required: true,
                          message: "Room Category is required!",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select a Room Category"
                        optionFilterProp="label"
                        options={categoryList}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={4}>
                    <Form.Item
                      name="room_type"
                      label="Room Type"
                      rules={[
                        { required: true, message: "Room Type is required!" },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Select a Room Type"
                        optionFilterProp="label"
                        options={ROOM_CAPACITY_TYPES}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item
                      name="occupancy"
                      label="Occupancy"
                      rules={[
                        { required: true, message: "Room Occupancy is required!" },
                      ]}
                    >
                      <Input type="text" placeholder="Occupancy" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="room_facility"
                      label="Room Facility"
                      rules={[
                        {
                          required: true,
                          message: "Room Facility is required!",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        allowClear
                        mode="multiple"
                        placeholder="Select a Room Facility"
                        optionFilterProp="label"
                        options={facilityList}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      type="file"
                      name="room_image"
                      label="Room Images"
                      rules={[
                        { required: true, message: "Room Images is required!" },
                      ]}
                    >
                      <Input
                        type="text"
                        readOnly
                        onClick={openDialog}
                        value={
                          selectedImages.length === 0
                            ? "Click to select image"
                            : selectedImages.length
                        }
                        name="room_image"
                        placeholder="Click to select image"
                      />

                      {selectedImages.length !== 0 ? (
                        <List
                          grid={{
                            gutter: 16,
                            column: 3,
                          }}
                          dataSource={selectedImages}
                          renderItem={(element) => (
                            <Space>
                              <Avatar
                                size={{
                                  xs: 24,
                                  sm: 32,
                                  md: 40,
                                  lg: 64,
                                  xl: 80,
                                  xxl: 100,
                                }}
                                src={IMAGE_BASE_URL + element.filePath}
                                shape="square"
                              />
                              <Avatar
                                shape="circle"
                                size="small"
                                icon={
                                  <DeleteOutlined
                                    onClick={() =>
                                      removeSelectedImage(element.filePath)
                                    }
                                  />
                                }
                              />
                            </Space>
                          )}
                        />
                      ) : null}
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="seo_title"
                      label="SEO Title (Title Tag)"
                      rules={[
                        { required: true, message: "SEO Title is required!" },
                        {
                          min: 1,
                          max: 60,
                          message:
                            "SEO Title must be between 50 and 60 characters.",
                        },
                      ]}
                    >
                      <Input placeholder="SEO Title (Title Tag)" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="seo_keyword"
                      label="SEO Keyword"
                      rules={[
                        { required: true, message: "SEO Keyword is required!" },
                        {
                          min: 1,
                          max: 50,
                          message:
                            "SEO Keyword should be between 1 and 50 characters.",
                        },
                      ]}
                    >
                      <Input placeholder="SEO Keyword" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="seo_description"
                      label="SEO Meta Description"
                      rules={[
                        {
                          required: true,
                          message: "SEO Meta Description is required!",
                        },
                        {
                          min: 1,
                          max: 160,
                          message:
                            "SEO Meta Description must be between 150 and 160 characters.",
                        },
                      ]}
                    >
                      <Input placeholder="SEO Meta Description" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      name="slug"
                      label="Slug"
                      rules={[{ required: true, message: "Slug is required!" }]}
                    >
                      <Input disabled type={"text"} placeholder="Slug" />
                    </Form.Item>
                    <Form.Item
                      name="room_check_in"
                      label="Room Check In"
                      style={{ width: "100%" }}
                      rules={[
                        {
                          required: true,
                          message: "Room Check In is required!",
                        },
                      ]}
                    >
                      <TimePicker
                        style={{ width: "100%" }}
                        defaultOpenValue={dayjs("00:00:00", "HH:mm:ss")}
                      />
                    </Form.Item>

                    <Form.Item
                      name="room_check_out"
                      label="Room Check Out"
                      style={{ width: "100%" }}
                      rules={[
                        {
                          required: true,
                          message: "Room Check Out is required!",
                        },
                      ]}
                    >
                      <TimePicker
                        style={{ width: "100%" }}
                        defaultOpenValue={dayjs("00:00:00", "HH:mm:ss")}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={18}>
                    <Form.Item
                      name="room_description"
                      label="Room Description"
                      rules={[
                        {
                          required: true,
                          message: "Room Description is required!",
                        },
                      ]}
                    >
                      <JoditEditor placeholder="Room Description" />
                    </Form.Item>
                  </Col>
                </Row>
                <Divider />
                <strong>OTA Config</strong>
                <br />
                <br />
                <Col span={24}>
                  <Form.Item
                    name="ota_room_code"
                    label="Ota Room Code"
                    rules={[
                      { required: true, message: "Ota Room Code is required!" },
                      {
                        min: 1,
                        max: 50,
                        message:
                          "Ota Room Code should be between 1 and 50 characters.",
                      },
                    ]}
                  >
                    <Input placeholder="Ota Room Code" />
                  </Form.Item>
                </Col>
                <Form.List name="ota_configs">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <div
                          key={key}
                          style={{
                            marginBottom: 24,
                            border: "1px solid #f0f0f0",
                            padding: 16,
                            borderRadius: 4,
                          }}
                        >
                          <Row gutter={[16, 16]}>
                            <Col span={6}>
                              <Form.Item
                                {...restField}
                                name={[name, "ota_room_service"]}
                                label="OTA Room Service"
                                rules={[
                                  {
                                    required: true,
                                    message: "OTA Room Service is required!",
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  placeholder="Select a OTA Room Service"
                                  optionFilterProp="label"
                                  options={OTA_SERVICE_TYPE}
                                />
                              </Form.Item>
                            </Col>

                            <Col span={6}>
                              <Form.Item
                                {...restField}
                                name={[name, "ota_room_type"]}
                                label="Room Type"
                              >
                                <Select
                                  showSearch
                                  placeholder="Select a Room Type"
                                  optionFilterProp="label"
                                  options={ROOM_CAPACITY_TYPES}
                                />
                              </Form.Item>
                            </Col>

                            <Col span={6}>
                              <Form.Item
                                {...restField}
                                name={[name, "ota_price"]}
                                label="Price"
                              >
                                <Input
                                  type="number"
                                  placeholder="Enter Price"
                                />
                              </Form.Item>
                            </Col>

                            <Col
                              span={6}
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Button danger onClick={() => remove(name)}>
                                Remove
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      ))}

                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          block
                          icon="+"
                        >
                          Add OTA Config
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>

                <Row spceber>
                  <Col span={24}>
                    <Form.Item
                      style={{ float: "right" }}
                      label=""
                      colon={false}
                    >
                      <Button loading={loading} block htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Spin>
        </Content>
        <LayoutFooter />
        <ImageSelect
          isOpen={isDialogOpen}
          onClose={closeDialog}
          onOk={handleDialogOk}
          fromMager={false}
        />
      </Layout>
    </>
  );
}
export default RoomAdd;
